import {
  enqueueKitchenSyncItem,
  type KitchenSyncQueueItem,
} from '@/shared/sync/kitchenSyncQueue'

let lastSyncQueued = false

/** True sekali setelah operasi terakhir masuk antrean sinkron (offline / gagal jaringan). */
export function consumeLastSyncQueued(): boolean {
  const queued = lastSyncQueued
  lastSyncQueued = false
  return queued
}

function isNetworkFailure(err: unknown): boolean {
  if (err instanceof TypeError) return true
  if (err instanceof Error) {
    const message = err.message.toLowerCase()
    return (
      message.includes('failed to fetch') ||
      message.includes('network') ||
      message.includes('offline')
    )
  }
  return false
}

export async function runKitchenSync<T>(
  item: Omit<KitchenSyncQueueItem, 'id' | 'createdAt'>,
  onlineFn: () => Promise<T>,
  offlineResult: () => T,
): Promise<T> {
  if (typeof navigator !== 'undefined' && !navigator.onLine) {
    enqueueKitchenSyncItem(item)
    lastSyncQueued = true
    return offlineResult()
  }

  try {
    lastSyncQueued = false
    return await onlineFn()
  } catch (err) {
    if (isNetworkFailure(err)) {
      enqueueKitchenSyncItem(item)
      lastSyncQueued = true
      return offlineResult()
    }
    lastSyncQueued = false
    throw err
  }
}
